import { gsap } from "gsap";

export default class EventInfo {
	constructor(el) {
		// DOM elements
		this.el = el;

		this.collapse = this.el.querySelector('[data-event-info-collapse]');
        this.wysiwyg = this.collapse.querySelector('.wysiwyg');
		this.toggleButton = this.el.querySelector('[data-event-toggle]');

        this.scrollHeight = this.wysiwyg.scrollHeight;
        this.clientHeight = this.wysiwyg.clientHeight;

        if(this.clientHeight==this.scrollHeight) {
            this.toggleButton.setAttribute('disabled', true);
        }

		// Status
		this.detailsOpen = false;
		this.animating = false;

		// Event listeners
		this.toggleButton.addEventListener('click', this.toggleDetails.bind(this));
	}

	/**
	 * @param {boolean} value
	 */
	set open(value) {
		this.detailsOpen = value;

		if (value) {
			this.el.classList.add('is-open');
		} else {
			this.el.classList.remove('is-open');
		}

		if(this.detailsOpen) {
			this.toggleButton.setAttribute('aria-expanded', true);
		} else {
			this.toggleButton.setAttribute('aria-expanded', false);
		}
	}

	set opening(value) {
		if (value) {
			this.el.classList.add('is-opening');
		} else {
			this.el.classList.remove('is-opening');
		}
	}

	get open() {
		return this.detailsOpen;
	}

	toggleDetails() {
		if (this.animating) {
			return;
		}

		if (this.open) {
			this.closeDetails();
		} else {
			this.openDetails();
		}
	}

	openDetails() {
		this.animating = true;
		this.opening = true;
		this.collapse.removeAttribute('inert');

        const tl = gsap.timeline({
            onComplete: () => {
                this.animating = false;
			    this.open = true;
            }
        });
		tl.fromTo(this.collapse, {
            height: this.wysiwyg.clientHeight
        }, {
            height: this.wysiwyg.scrollHeight,
            duration: 0.2,
            ease: 'power2.inOut'
        });
	}

	closeDetails() {
		this.animating = true;
		this.opening = false;
		this.collapse.setAttribute('inert', '');

        const tl = gsap.timeline({
            onComplete: () => {
                this.animating = false;
			    this.open = false;
            }
        });

        tl.fromTo(this.collapse, {
            height: this.wysiwyg.scrollHeight
        }, {
            height: this.clientHeight,
            duration: 0.2,
            ease: 'power2.inOut'
        });

	}
}

